const acceptedImageTypes = [
    { type: 'image/svg+xml', label: 'SVG', extensions: '.svg' },
    { type: 'image/png', label: 'png', extensions: '.png' },
    { type: 'image/webp', label: 'webp', extensions: '.webp' },
    { type: 'image/jpeg', label: 'jpeg', extensions: '.jpeg,.jpg' },
];
const maxImageSize = 2_000_000; // 2Mo

export { acceptedImageTypes, maxImageSize };
